module.exports = __webpack_public_path__ + "img/harald_schumann2.e44c88c4.png";